export const BRANCH_VIDEO_PARENT_CONFIRMATION_ALIAS =
  'video_branch_parent_confirm';
